import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { DataContext } from '../contexts';
import CopycatBibframeEdit from '../components/CopycatRecord/CopycatEdit/CopycatBibframeEdit/CopycatBibframeEdit';

function CopycatBibEditRoute(props) {
  const { id: importId } = useParams();
  const referenceData = useContext(DataContext);

  console.log('referenceData', referenceData);

  return (
    <CopycatBibframeEdit
      importId={importId}
      referenceData={referenceData}
      {...props}
    />
  );
}

CopycatBibEditRoute.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.object,
};

export default CopycatBibEditRoute;
